<template>
  <div class="pagination-container row" aria-label="Pagination">
    <div class="col-sm-12 col-md-6 left-slot-container">
      <div class="dataTables_length">
        <label>
          Display
          <select v-model="per_page" class="custom-select custom-select-sm">
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="100">100</option>
            <option value="-1">All</option>
          </select>
          records
        </label>
      </div>
      <slot name="left-slot"></slot>
    </div>
    <div class="col-sm-12 col-md-6 right-slot-container">
      <div class="dataTables_filter" v-if="showSearch">
        <label>
          Search:
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="search"
            @keyup.enter="reset"
          />
        </label>
      </div>
      <slot name="right-slot"></slot>
    </div>
  </div>
</template>

<script>
export default {
  /*     model: {
        prop: "metadata",
        event: "change",
    }, */
  props: {
    results: Array,
    metadata: Object,
    showSearch: {
      type: Boolean,
      default: true,
    },
    searchText: String,
  },
  data() {
    return {
      per_page: null,
      updating: false,
      search: null,
    };
  },
  watch: {
    searchText(val) {
      this.search = val;
    },
    metadata: {
      handler: function(val) {
        if (val.per_page) {
          this.updating = true;
          this.per_page = val.per_page;
          if (val.search) {
            this.search = val.search;
          }
          this.$nextTick(() => {
            this.updating = false;
          });
        }
      },
      immediate: true,
    },
    per_page() {
      if (!this.updating) {
        this.reset();
      }
    },
  },
  methods: {
    go(page) {
      // this.metadata.current_page = page;
      this.$emit("change", page);
    },
    goPrevious() {
      if (this.page > 1) {
        // this.metadata.current_page--;
        this.go(this.page - 1);
      }
    },
    goNext() {
      if (this.page < this.totalPage) {
        // this.metadata.current_page++;
        this.go(this.page + 1);
      }
    },
    reset() {
      this.$emit("input:searchText", this.search);
      this.$emit("reset", [this.per_page, this.search]);
    },
    perpageActiveClass(per_page) {
      if (this.metadata.per_page == per_page) {
        return "active";
      }
    },
  },
  computed: {
    page() {
      return this.metadata.current_page;
    },
    total() {
      if (this.metadata && this.metadata.total) {
        return this.metadata.total;
      } else {
        return this.results.length;
      }
    },
    totalPage() {
      return this.metadata.last_page;
    },
  },
};
</script>

<style></style>
